"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let BulkContractServiceEditor = class BulkContractServiceEditor extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    getPayload(...args) {
        const item = this.item;
        const value = item.getChanges();
        return _.map(this.items, p => ({ id: p.id, value }));
    }
    items;
    onItems(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("items");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    labelAlign;
    item;
    async $$load_item() {
        return this.$fn.schemaDefaults('CreateContractService', { asResource: true });
    }
    services;
    async $$load_services() {
        return this.$fn.fetch('suggest_product', {
            parameters: { query: '*', top: 50, skip: 0, product_types: 'service', product_invoice_groups: 'all' }
        }).then(data => _.orderBy(data, [p => p.name.toLowerCase()]));
    }
    invoiceGroups;
    async $$load_invoiceGroups() {
        return this.$fn.fetch('list_product_invoice_group');
    }
    ux;
    b_7315092382398562_modalBindings;
    b_3054425420812800_multiple;
    dataMembers = ['formId', 'labelAlign', 'item', 'services', 'invoiceGroups', 'ux', 'b_7315092382398562_modalBindings', 'b_3054425420812800_multiple'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                labelAlign: "right",
                item: null,
                services: null,
                invoiceGroups: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    noPrimaryButton: true,
                    closeButtonText: this.$fn.gettext("Close"),
                    size: "lg",
                },
                b_3054425420812800_multiple: false,
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("BulkContractServiceEditor", "Edit Service Properties"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_8768_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_8774_getActionArgs($event) {
        return {
            result: {
                close: true,
                ok: true,
                value: $event.data.response.data,
            },
        };
    }
    async act_1040167445267876_request_8772_getActionArgs($event) {
        return {
            operation: "bulk_update_contract_service",
            data: this.getPayload(),
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_5731695935601903_setData_8776_getActionArgs($event) {
        return {
            path: "item.name",
            value: $event.data.option.name,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_5731695935601903_setData_8778_getActionArgs($event) {
        return {
            path: "item.service_id",
            value: $event.data.option.id,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_5731695935601903_setData_8780_getActionArgs($event) {
        return {
            path: "feeItem.unit",
            value: $event.data.option.unit,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_5731695935601903_optionSelected(event, scope) {
        return await this.actions.evh_5731695935601903_optionSelected.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_8768 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_8768_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_8767 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_8768,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_8767],
        });
        const act_2248226175642056_closeComponent_8770 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_8769 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_8770,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_8769],
        });
        const act_1040167445267876_closeModal_8774 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_8774_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_8773 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_8774,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_request_8772 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_8772_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_8773],
        });
        const evh_1040167445267876_submit_8771 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_8772,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_8771],
        });
        const act_5731695935601903_setData_8776 = new core_1.actions.SetDataAction({
            actionArgs: this.act_5731695935601903_setData_8776_getActionArgs,
            events: [],
        });
        const evh_5731695935601903_optionSelected_8775 = new core_1.actions.EventHandlerImpl({
            action: act_5731695935601903_setData_8776,
            event: "optionSelected",
            displayName: "setData",
        });
        const act_5731695935601903_setData_8778 = new core_1.actions.SetDataAction({
            actionArgs: this.act_5731695935601903_setData_8778_getActionArgs,
            events: [],
        });
        const evh_5731695935601903_optionSelected_8777 = new core_1.actions.EventHandlerImpl({
            action: act_5731695935601903_setData_8778,
            event: "optionSelected",
            displayName: "setData",
        });
        const act_5731695935601903_setData_8780 = new core_1.actions.SetDataAction({
            actionArgs: this.act_5731695935601903_setData_8780_getActionArgs,
            events: [],
        });
        const evh_5731695935601903_optionSelected_8779 = new core_1.actions.EventHandlerImpl({
            action: act_5731695935601903_setData_8780,
            event: "optionSelected",
            displayName: "setData",
        });
        const evh_5731695935601903_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5731695935601903_optionSelected_8775, evh_5731695935601903_optionSelected_8777, evh_5731695935601903_optionSelected_8779],
        });
        const act_1419464017721962_closeComponent_8782 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_8781 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_8782,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_8781],
        });
        return {
            act_7315092382398562_closeModal_8768,
            evh_7315092382398562_close_8767,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_8770,
            evh_2248226175642056_close_8769,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_8774,
            evh_1040167445267876_success_8773,
            act_1040167445267876_request_8772,
            evh_1040167445267876_submit_8771,
            evh_1040167445267876_submit,
            act_5731695935601903_setData_8776,
            evh_5731695935601903_optionSelected_8775,
            act_5731695935601903_setData_8778,
            evh_5731695935601903_optionSelected_8777,
            act_5731695935601903_setData_8780,
            evh_5731695935601903_optionSelected_8779,
            evh_5731695935601903_optionSelected,
            act_1419464017721962_closeComponent_8782,
            evh_1419464017721962_clickPreventStop_8781,
            evh_1419464017721962_clickPreventStop,
            save: act_1040167445267876_request_8772,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Array,
    }),
    __metadata("design:type", typeof (_a = typeof array !== "undefined" && array) === "function" ? _a : Object)
], BulkContractServiceEditor.prototype, "items", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('items'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BulkContractServiceEditor.prototype, "onItems", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], BulkContractServiceEditor.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BulkContractServiceEditor.prototype, "onSize", null);
BulkContractServiceEditor = __decorate([
    (0, vue_property_decorator_1.Component)()
], BulkContractServiceEditor);
exports.default = BulkContractServiceEditor;
vue_property_decorator_1.Vue.component("BulkContractServiceEditor", BulkContractServiceEditor);
